/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2NurseCap/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2NurseCap({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2NurseCap",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 15,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2NurseCap.Svg"
  data-view-path={viewPath}
 viewBox="0 0 15 12"
 style={{'--as-1-ElaSK': alignSelf,'--mt-2-ElaSK': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ElaSK': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ElaSK': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ElaSK': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ElaSK': opacity,'--w-10-ElaSK': typeof width === 'number' ? `${width}px` : width,'--h-11-ElaSK': typeof height === 'number' ? `${height}px` : height,'--f-12-ElaSK': fill,'--a-7-ElaSK': isAnimated ? animation : "none",'--sd-8-ElaSK': isAnimated ? strokeDashoffset : 0,'--sd-9-ElaSK': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2NurseCap.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M9.915.001H5.041A1.67 1.67 0 004.04.29c-.29.198-.507.481-.617.809l-.8 1.933c3.218-.51 6.52-.51 9.739-.003l-.83-1.934a1.602 1.602 0 00-.615-.805A1.67 1.67 0 009.915 0zm4.682 4.836a.523.523 0 01.376.673l-1.93 5.756a1.09 1.09 0 01-1.04.734H2.997a1.09 1.09 0 01-1.039-.734L.027 5.51a.522.522 0 01.376-.673 29.787 29.787 0 0114.194 0zM5.86 7.323a.675.675 0 00-.684.665c0 .368.306.666.684.666h.956v.932c0 .367.306.665.683.665a.675.675 0 00.683-.665v-.932h.956a.675.675 0 00.684-.666.675.675 0 00-.684-.665h-.956V6.39a.675.675 0 00-.683-.666.675.675 0 00-.683.666v.932H5.86z"
 style={{'--f-12-ElaSK': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}